// External Imports
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

// PPUI Imports
import { Container } from '@paypalcorp/pp-react-grid';

// Internal Imports
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import { validate } from '../../lib/clientValidatorV3';
import MailingAddressSwitch from './components/MailingAddressSwitch';
import Note from './components/Note';
import StepHeader from './components/StepHeader';
import AdvancedUrls from './components/AdvancedUrls';
import AdvancedVariables from './components/AdvancedVariables';
import WizardNavButtons from '../navigationButtons/WizardNavButtons';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';
import { trackEventWithData } from '../../utilsV3/analytics';

const WizardStep4 = ({ handleBack, handleSubmit, formValues, application }) => {
  const trackPageLoadImpression = () => {
    trackEventWithData(FPTI_SPEC.ADVANCED_SETTINGS_PAGE_IM, { step: 4 });
  };

  useEffect(() => {
    trackPageLoadImpression();
  }, []);

  return (
    <>
      <Container className="wizard-step-container wizard-step-4-container">
        <StepHeader />

        <form onSubmit={handleSubmit} className="wizard-form">
          <MailingAddressSwitch isChecked={formValues.noShipping === 'no'} />
          <Note
            isChecked={formValues.noNote === 'no'}
            showBadge={application.showNewFeatureBadge ?? false}
          />
          <AdvancedUrls noCancelReturn={formValues.noCancelReturn} />
          <AdvancedVariables
            extraVariablesView={formValues.extraVariablesView}
            noAdvancedVariables={formValues.noAdvancedVariables}
          />
        </form>
      </Container>
      <WizardNavButtons handleBack={handleBack} handleSubmit={handleSubmit} />
    </>
  );
};

WizardStep4.propTypes = {
  buttonFactoryV3: PropTypes.object,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  application: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

let WizardStep4Form = reduxForm({
  form: BTN_FACTORY_V3_FORM,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(WizardStep4);

WizardStep4Form = connect(mapStateToProps)(WizardStep4Form);

export default WizardStep4Form;
